import React        from 'react';

import WP_API       from './apis/wp-api';
import Loading      from './bits/Loading';
import Error        from './bits/Error';
import Header       from './ui/Header';
import Footer       from './ui/Footer';
import Where        from './views/Where';
import What         from './views/What';
import Page         from './views/Page';
import Colovr       from './views/Colovr';
import Success      from './views/Success';

import './assets/libs/mapbox/mapbox-gl.css';//0.49
//import './assets/libs/mapbox/mapbox-gl-geocoder.css';//0.49

import './assets/css/style.css';


class App extends React.Component {

    //PAGELOAD = true;
    gametype = null;//'where';

    gameguidetext = {
        'where': "Can you guess where are these famous places shown in the DISTORTED image(s)? How well can you locate them on a map? Looking around, except zoom, is limited by default but you can remove restrictions at any time. Once you're ready to answer, click the main button and select location by clicking on the map.",
        'what': "Can you guess what are these things shown in the DISTORTED image(s)? How well can you tell what is shown in the image? Looking around, except zoom, is limited by default but you can remove restrictions at any time. Once you're ready to answer, click the main button and select from the options."
    }

    gameguide = null;

    init_state = {
        loading: true,
        error: false,
        success: false,
        failure: false,
        points: 0,
        points_total: 0,//cumulative points per mission
        points_max: 20000,//points per task
        points_max_total: 0,
        task_counter: 0,
        showContent: 'showColovr',
        task_ended: false,
        mission: null,
        ui_locked: false,
        camera_normal: false,
        custom_button: null
    }

    state = this.init_state;


    componentDidMount(){

        this.newGame();

            if(window.visualViewport){
                setTimeout(function () {
                    let viewport = document.querySelector("meta[name=viewport]");
                    viewport.setAttribute("content", "height=" + window.visualViewport.height + ", width=" + window.visualViewport.width + ", initial-scale=1.0");
                }, 300);
            }
    }


    newGame = () => {

        this.setState(this.init_state);

        /*Object.keys(localStorage).forEach(function(c,i,a){
            console.log(c, i ,a);
            localStorage.removeItem(c);
        });*/

        this.loadData();
    }
    

    loadData = async ()=> {

        const game = (this.state.game || (window.playGame || 1026));

        await WP_API.get('data/?url=/wp-json/wp/v2/vr_games/' + game + '/?_embed&vr_game=' + game)
        .then(response => {

            window.colovr.allData = response.data;
            //console.log(window.colovr.allData);

            this.setState({
                game: game,
                mission: window.colovr.allData,
                loading: false,
                error: false,
                points_max_total: window.colovr.allData.vr_images.length * this.state.points_max,
                success: false,//(localStorage.success || false),
                failure: false//(localStorage.failure || false),
            });

            this.gametype = (window.colovr.allData.vr_game_type || null);

                if(this.gametype){ 
                    require('./assets/css/' + this.gametype + '.css');//whole string can't be variable
                }

            document.querySelector('body').classList.remove('colovr-loading');

            this.startMission();
            
        })
        .catch(error => {
            console.log(error);
            this.setState({error: true, loading: false});
        });
    }


    startMission =()=>{

        window.colovr.triggers.afterinit.gueff =()=>{
            this.changeView.goSmallPlanet();
            this.showContent('showInfo', true);
        }

        window.colovr.triggers.afterframe.gueff =()=>{
            window.colovr.viewer.renderOnDemand();
        }

        window.colovr.options.autorotate = 0;
        window.colovr.options.mapBox.enabled = 0;
        window.colovr.options.fov.start = window.colovr.options.fov.max;
        window.colovr.options.fov.min = 30;
        window.colovr.options.navigator.mode = 0;
        window.colovr.options.autorender = 0;
        window.colovr.init();
    }


    //doesn't run on load as colovr runs automatically
    startTask =(cnt)=> {

        window.colovr.jumpToFrame(cnt + 1);

        this.setState({
            showContent: 'showColovr',
            ui_locked: false,
            task_counter: cnt,
            camera_normal: false,
            task_ended: false
        });

        this.changeView.goSmallPlanet();

    }

    //doesn't run on load as colovr runs automatically
    endTask =()=> {

        this.setState({
            task_ended: true
        });

    }


    changeView = {

        goSmallPlanet: function(){
            window.colovr.viewer.threeControls.minPolarAngle = 0.000001;
            window.colovr.viewer.threeControls.maxPolarAngle = window.colovr.viewer.threeControls.minPolarAngle;
            window.colovr.viewer.camera.position.set(0, 0, window.colovr.viewer.threeControls.maxDistance);
            window.colovr.goSmallPlanet();
            window.colovr.viewer.threeControls.maxPolarAngle = 0.6;
            window.colovr.viewer.renderOnDemand();
        },

        goWormhole: function(){
            window.colovr.viewer.threeControls.minPolarAngle = Math.PI;
            window.colovr.viewer.threeControls.maxPolarAngle = window.colovr.viewer.threeControls.minPolarAngle;
            window.colovr.viewer.camera.position.set(0, 0, window.colovr.viewer.threeControls.maxDistance);
            window.colovr.goWormhole();
            window.colovr.viewer.threeControls.minPolarAngle = Math.PI - 0.6;
            window.colovr.viewer.renderOnDemand();
        },

        goNormal: function(){
            window.colovr.viewer.threeControls.minPolarAngle = 0.000001;
            window.colovr.viewer.threeControls.maxPolarAngle = Math.PI;
            window.colovr.viewer.camera.fov = 66;
            window.colovr.options.fov.min = 10;
            window.colovr.viewer.camera.position.set(0, 0, 1);
            window.colovr.viewer.threeControls.reset();
            window.colovr.viewer.renderOnDemand();
            window.colovr.viewer.camera.updateProjectionMatrix();
        }
    }


    normalView(){
        this.splitPoints();
        this.showContent('showColovr', false);
        this.changeView.goNormal();
    }


    showContent = (comp, lock_ui) =>{

            if(comp === this.state.showContent){
                this.setState({
                    showContent: 'showColovr',
                    ui_locked: false
                });
                window.colovr.resizer();
                return;
            }

        this.setState({
            showContent: comp,
            ui_locked: lock_ui
        });

        window.scrollTo(0, 0);
    }


    hideContent = (comp) =>{
        this.setState({
            showContent: comp
        });
    }


    pointOfNoReturn =()=>{

        this.setState({
            ui_locked: true,
            custom_button: null
        });
    }


    addFooterButton =(elem)=>{
        this.setState({
            custom_button: elem
        });
    }


    /*removeFooterButton =()=>{
        this.setState({
            custom_button: null
        });
    }*/


    padString = (num, padlen, padchar) => {
        var pad_char = typeof padchar !== 'undefined' ? padchar : '0';
        var pad = new Array(1 + padlen).join(pad_char);
        return (pad + num).slice(-pad.length);
    }


    updatePoints =(pts)=>{
        this.endTask();

        this.setState({
            points_total: this.state.points_total + parseInt(pts)
        });
    }


    goSuccess =()=>{

        this.setState({
            success: true
        });
    }


    goFailure = () => {

        this.setState({
            failure: true,
            points: 0
        });
        //localStorage.setItem("failure", true)
    }
    

    splitPoints =()=> {

        this.setState({
            points_max: this.state.points_max/2,
            camera_normal: true
        });
        //localStorage.setItem( 'storage_points', this.state.points + pts );
    }


    render(){

            if(this.state.loading) return <Loading classes={"esd-loading-block"} />

            if(this.state.error) return <Error callback={this.loadData} />

        let content = '';

        const hint_content = <Page title="Stuck and need help?" content={<><div className="page-content-header"><i className="material-icons g-icon-huge">star_half</i></div><p>By allowing free movement it easier to look around. This will cost you half the points of the current view!</p><h3>Remove restrictions?</h3><div className="btn-group btn-group-double"><button className="btn-no" onClick={()=>this.showContent('showColovr', false)}><i className="material-icons">block</i></button><button className="btn-ok" onClick={()=>this.normalView()}><i className="material-icons">done</i></button></div></>} />

        let info_element = '';

            if(this.gametype) info_element =  <><p>{this.gameguidetext[this.gametype]}</p><p>Moving between views is controlled with button center bottom of page. You also move to the next task with this button. Keep clicking it!</p><p> You can change view, either to "small planet" or "wormhole", by clicking buttons on top right of the page.</p><div className="btn-group btn-group-single"><button className="btn-primary btn-ok" onClick={()=>this.showContent('showColovr', false)}><i className="material-icons">done</i></button></div><h3>Stuck?</h3><p>If you can't figure out the solution from distorted view you can click button on bottom right corner and allow free movement. This will half your points for the current task.</p><div className="btn-group btn-group-single"><button className="btn-primary btn-ok" onClick={()=>this.showContent('showColovr', false)}><i className="material-icons">done</i></button></div></>

        const info_content = <Page id="infoPage" title="How to play" content={info_element}/>

        let contObj = {
            'showHint': hint_content,
            'showInfo': info_content
        }

        content = contObj[this.state.showContent];

            if(this.state.success) content = <Success points_max_total={this.state.points_max_total} points_total={this.state.points_total} mission_length={this.state.mission.vr_images.length} success_rate={parseInt(((this.state.points_total/this.state.points_max_total) * 100).toFixed(1))} gametype={this.gametype} game_id={this.state.game} game_name={window.playGameName}/>

        //gametype    
        let taskcontainer = '';
        
        switch (this.gametype) {
            case 'where':
                taskcontainer = <Where classes={(this.state.showContent === 'showTask' ? 'g-view-in' : 'g-view-out')} task={(this.state.mission.vr_images[this.state.task_counter] || null)} ui_locked={this.state.ui_locked} pointOfNoReturn={this.pointOfNoReturn} points_max={this.state.points_max} updatePoints={this.updatePoints} task_ended={this.state.task_ended} />
            break;

            case 'what':

                    if(this.state.showContent === 'showTask') taskcontainer = <What addButton={this.addFooterButton} classes={(this.state.showContent === 'showTask' ? 'g-view-in' : 'g-view-out')} task={(this.state.mission.vr_images[this.state.task_counter] || null)} pointOfNoReturn={this.pointOfNoReturn} points_max={this.state.points_max} updatePoints={this.updatePoints} mission={this.state.mission} task_ended={this.state.task_ended} missionended={(this.state.success || this.state.failure)} />
                    else taskcontainer = '';//needs to unmount, no need to keep in the dom. Also this container can be unmounted.
            
                break;

            default:
                taskcontainer = <Error msg="No game type selected" callback={()=> window.location.reload()}/>
        }
        // /gametype


        return(
                <>  
                    {(!this.state.success ? taskcontainer : '')}
                    <Colovr classes={(this.state.showContent === 'showColovr' ? 'g-view-in' : 'g-view-out')} />
                    {content}
                    <Header ui_locked={(this.state.ui_locked || this.state.camera_normal)} goPlanet={this.changeView.goSmallPlanet} goHole={this.changeView.goWormhole} showContent={this.showContent} newGame={this.newGame}/>
                    <Footer custombutton={this.state.custom_button} ui_locked={this.state.ui_locked} hide_hint={this.state.camera_normal} missionended={(this.state.success || this.state.failure)} counter={this.state.task_counter} counter_max={this.state.mission.vr_images.length} task={(this.state.mission.vr_images[this.state.task_counter] || null)} showContent={this.showContent} current_content={this.state.showContent} start={this.startTask} task_ended={this.state.task_ended} newGame={this.newGame} goSuccess={this.goSuccess} />
                    {(this.state.success || (this.state.showContent !== 'showColovr' &&  this.state.showContent !== 'showTask') ? '' : <div id="pointsInfo"><p><i className="material-icons icon">star</i>{this.padString(this.state.points_total, this.state.points_max_total.toString().length, 0)}</p><div><span style={{'width': Math.ceil((this.state.task_counter+1)/this.state.mission.vr_images.length*100)+'%'}}></span></div></div>)}
                    <div id="opDebug" className={(window.location.hostname === 'localhost' ? 'g-show' : 'g-hide')}>
                        {(this.state.task_counter > -1 && !this.state.success? <button onClick={this.failure} className="btn"><i className="material-icons">not_interested</i></button>  : '')}
                        <button onClick={this.newGame} className="btn"><i className="material-icons">replay</i></button>
                    </div>
                </>
            )
        }
}


export default App;